export const menuActions = [
  [ 
    {
      name: 'clearall',
      key:'n',
      ctrlKey: true,
      shiftKey: false,
      iconname: 'sort amount up',
    },
  ],
];
